var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apply-main"},[_c('PageTop',{staticClass:"bg-gray",attrs:{"page":"apply"}}),_c('ApplyForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }